module.exports = __webpack_public_path__ + "img/HD_gg_logo_2_71b4594be.png";